import { render, staticRenderFns } from "./optionsdialog.vue?vue&type=template&id=5a328193&scoped=true&"
import script from "./optionsdialog.vue?vue&type=script&lang=js&"
export * from "./optionsdialog.vue?vue&type=script&lang=js&"
import style0 from "./optionsdialog.vue?vue&type=style&index=0&id=5a328193&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a328193",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willy/code/fake-the-wheel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a328193')) {
      api.createRecord('5a328193', component.options)
    } else {
      api.reload('5a328193', component.options)
    }
    module.hot.accept("./optionsdialog.vue?vue&type=template&id=5a328193&scoped=true&", function () {
      api.rerender('5a328193', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/optionsdialog.vue"
export default component.exports